import { PLATFORMS } from './constants.js'

export default function getUsername(post) {
  if (!post) return null

  const { sourceName, userRealName, userName } = post

  if ([PLATFORMS.TWITTER, PLATFORMS.INSTAGRAM].includes(sourceName) && userName) {
    return `@${userName}`
  }

  return userRealName || userName
}
